import { EnumEmailCategory } from './Generated';
import type { SelectOption } from '@synqo/frontend-component-library';

export const getEnumEmailCategoryLabel = (value: EnumEmailCategory) => {
    switch (value) {
        case EnumEmailCategory.Invoice:
            return 'Rechnungen';
        case EnumEmailCategory.Order:
            return 'Aufträge';
        case EnumEmailCategory.Invitation:
            return 'Einladungen';
        case EnumEmailCategory.PasswordReset:
            return 'Passwort-Zurücksetzung';
        case EnumEmailCategory.Notification:
            return 'Benachrichtigungen';
        default:
            return 'Nicht definiert';
    }
};

export const emailCategoryOptions: SelectOption<EnumEmailCategory>[] = [
    {
        name: 'invoice',
        label: getEnumEmailCategoryLabel(EnumEmailCategory.Invoice),
        value: EnumEmailCategory.Invoice,
    },
    {
        name: 'order',
        label: getEnumEmailCategoryLabel(EnumEmailCategory.Order),
        value: EnumEmailCategory.Order,
    },
];
